import _defineProperty from "@babel/runtime/helpers/defineProperty";
var _PageStateLogger;
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 *
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { ClassUtils } from "abweb/utils/ClassUtils";
import { LogUtils } from "abweb/utils/log/LogUtils";
export class PageStateLogger {
  static calculateActiveLoggers() {
    const activeLoggerSet = new Set();
    const localStorageValue = localStorage && localStorage.getItem(PageStateLogger.LOG_VERBOSE_LOCAL_STORAGE_KEY);
    let errorMessage = undefined;
    if (localStorageValue) {
      let parsedLocalStorageValue = undefined;
      let parsingErrorMessage = `Invalid value found for ${PageStateLogger.LOG_VERBOSE_LOCAL_STORAGE_KEY} in localStorage: ${localStorageValue} Must be a json array of strings.`;
      try {
        parsedLocalStorageValue = JSON.parse(localStorageValue);
        if (typeof parsedLocalStorageValue !== 'object' || parsedLocalStorageValue.length === undefined) {
          errorMessage = parsingErrorMessage;
        }
      } catch (e) {
        errorMessage = parsingErrorMessage;
      }
      if (parsedLocalStorageValue) {
        parsedLocalStorageValue.forEach(val => {
          switch (val) {
            case "identity":
              activeLoggerSet.add("identity");
              break;
            case "state":
              activeLoggerSet.add("state");
              break;
            case "system":
              activeLoggerSet.add("system");
              break;
            case "all":
              activeLoggerSet.add("identity");
              activeLoggerSet.add("state");
              activeLoggerSet.add("system");
              break;
            default:
              errorMessage = `Invalid value found in localStorage for key ${PageStateLogger.LOG_VERBOSE_LOCAL_STORAGE_KEY}: ${val} must be one of identity, state, system, or all`;
          }
        });
      }
      if (errorMessage) {
        // can't log yet this early in system startup, so have to report using console.log
        console.log(`PageStateLogger ERROR: ${errorMessage}`);
      }
      PageStateLogger.activeLoggersInitialized = true;
      if (activeLoggerSet.size > 0) {
        let enabled = "";
        for (const category of activeLoggerSet.keys()) {
          enabled += `${enabled.length > 0 ? ", " : ""}${category}`;
        }
        console.log(`PageStateLogger enabled for ${enabled}`);
        return activeLoggerSet;
      } else {
        return undefined;
      }
    }
  }
  static enableLoggingCategories(...logCategories) {
    PageStateLogger.activeLoggers = new Set(logCategories);
    PageStateLogger.activeLoggersInitialized = true;
  }
  static logWarning(message) {
    PageStateLogger.LOG.info(`WARNING: ${message}`);
  }
  static logError(message) {
    PageStateLogger.LOG.error(message);
  }
  static messageWithCategory(category, message) {
    return `PageStateLogger-${category}: ${message}`;
  }
  static maybeLog(category, message) {
    if (!PageStateLogger.activeLoggersInitialized) {
      PageStateLogger.activeLoggers = PageStateLogger.calculateActiveLoggers();
    }
    if (PageStateLogger.activeLoggers?.has(category)) {
      PageStateLogger.LOG.info(PageStateLogger.messageWithCategory(category, message));
    }
  }
  static maybeLogFor(category, obj, message) {
    try {
      const className = obj ? ClassUtils.getClassname(obj) : "";
      PageStateLogger.maybeLog(category, `${className}: ${message}`);
    } catch (e) {
      // do nothing
    }
  }
}
_PageStateLogger = PageStateLogger;
_defineProperty(PageStateLogger, "LOG_VERBOSE_LOCAL_STORAGE_KEY", "page_state_verbose_logging");
_defineProperty(PageStateLogger, "LOG", LogUtils.getLogger(__filename));
_defineProperty(PageStateLogger, "activeLoggers", _PageStateLogger.calculateActiveLoggers());
_defineProperty(PageStateLogger, "activeLoggersInitialized", false);
//# sourceMappingURL=PageStateLogger.js.map
